import { CategorySearchState } from './types';

export const getSearchedCategoriesState = (state: any): CategorySearchState => state.searchCategory;
export const getSearchedCategories = (state: any): CategorySearchState['categories'] => state.searchCategory.categories;
